import { render, staticRenderFns } from "./PricingPlan.vue?vue&type=template&id=12b27da8&scoped=true&"
import script from "./PricingPlan.vue?vue&type=script&lang=js&"
export * from "./PricingPlan.vue?vue&type=script&lang=js&"
import style0 from "./PricingPlan.vue?vue&type=style&index=0&id=12b27da8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b27da8",
  null
  
)

export default component.exports